import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const ADDITIONAL_NOTIFY_METHOD_PATH = 'additionalNotifyMethod'
export function getPageAdditionalNotifyMethod(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${ADDITIONAL_NOTIFY_METHOD_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function createOrUpdateAdditionalNotifyMethod(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${ADDITIONAL_NOTIFY_METHOD_PATH}/createOrUpdate`,
            data,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function deleteByIdAdditionalNotifyMethod(userId, data) {
    return axiosInstance
        .delete(
            `${BACKEND_ENDPOINT}/${ADDITIONAL_NOTIFY_METHOD_PATH}/deleteById`,
            {
                params: {userId},
                data,
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
